var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7936 2.40602L22.8354 0.258071C22.6854 0.0936682 22.4733 0 22.2509 0H18.7418H6.25811H0.790819C0.354111 0 0 0.354023 0 0.790819V24.2092C0 24.646 0.354024 25 0.790819 25H24.2091C24.6459 25 24.9999 24.646 24.9999 24.2092V2.93886C24.9999 2.74177 24.9263 2.55171 24.7936 2.40602ZM17.951 1.58164V7.68351H14.792V1.58164H17.951ZM13.2104 1.58164V7.68351H7.04893V1.58164H13.2104ZM19.3822 23.4184H5.61781V14.0098H19.3821V23.4184H19.3822ZM23.4183 23.4184H20.9637V13.219C20.9637 12.7822 20.6097 12.4282 20.1729 12.4282H4.82699C4.39019 12.4282 4.03617 12.7822 4.03617 13.219V23.4183H1.58164V1.58164H5.46729V8.47433C5.46729 8.91113 5.82131 9.26515 6.25811 9.26515H18.7418C19.1786 9.26515 19.5326 8.91113 19.5326 8.47433V1.58164H21.9017L23.4183 3.24526V23.4184Z",
    fill: "#2A0C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.34950da4b83c5779e4a2a7bdeb35ab76.svg";
export { ForwardRef as ReactComponent };